import { Group, Badge, Text } from '@mantine/core';

interface MergeTag {
  tag: string;
  description: string;
}

interface MergeTagChipsProps {
  tags: MergeTag[];
  onInsert: (tag: string) => void;
}

/**
 * Clickable merge tag chips for inserting into email template
 */
export function MergeTagChips({ tags, onInsert }: MergeTagChipsProps) {
  return (
    <div>
      <Text size="xs" fw={500} c="dimmed" mb="xs" tt="uppercase">
        Insert Merge Tag
      </Text>
      <Group gap="xs">
        {tags.map((mergeTag) => (
          <Badge
            key={mergeTag.tag}
            variant="light"
            color="gray"
            size="md"
            style={{ cursor: 'pointer', fontFamily: 'monospace', textTransform: 'none' }}
            onClick={() => onInsert(mergeTag.tag)}
            title={mergeTag.description}
          >
            {mergeTag.tag}
          </Badge>
        ))}
      </Group>
    </div>
  );
}

export default MergeTagChips;
